import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// ページコンポーネント
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import JarvisChat from './pages/JarvisChat';
import Sessions from './pages/Sessions';
import SessionDetail from './pages/SessionDetail';
import BlueprintView from './pages/BlueprintView';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';
import UserManagement from './pages/UserManagement';
import ContactManagement from './pages/ContactManagement';
import InviteAccept from './pages/InviteAccept';
import ResetPassword from './pages/ResetPassword';

// レイアウト
import Layout from './components/Layout';
import LoadingScreen from './components/LoadingScreen';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return <LoadingScreen />;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return <LoadingScreen />;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  if (user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }
  
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      {/* パブリックルート */}
      <Route path="/" element={<JarvisChat />} />
      <Route path="/login" element={<Login />} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      
      {/* 認証必須ルート */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/sessions"
        element={
          <PrivateRoute>
            <Layout>
              <Sessions />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/sessions/:id"
        element={
          <PrivateRoute>
            <Layout>
              <SessionDetail />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/sessions/:id/blueprint"
        element={
          <PrivateRoute>
            <Layout>
              <BlueprintView />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Layout>
              <Profile />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/change-password"
        element={
          <PrivateRoute>
            <Layout>
              <ChangePassword />
            </Layout>
          </PrivateRoute>
        }
      />
      
      {/* 管理者ルート */}
      <Route
        path="/admin/users"
        element={
          <AdminRoute>
            <Layout>
              <UserManagement />
            </Layout>
          </AdminRoute>
        }
      />
      <Route
        path="/admin/contacts"
        element={
          <AdminRoute>
            <Layout>
              <ContactManagement />
            </Layout>
          </AdminRoute>
        }
      />
      
      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

